<ion-header>
  <ion-toolbar>
    <ion-title>Hive Edge BMS Token</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <ion-card>
    <ion-card-header>
      <ion-card-title>Verbindungs-Token</ion-card-title>
    </ion-card-header>
    <ion-card-content>
      <p>
        Um die Verbindung zwischen der <strong>Hive Edge BMS</strong> und dem
        <strong>Hive Portal</strong> herzustellen, muss der folgende Token in
        der BMS-Oberfläche eingegeben werden:
      </p>

      <ion-item color="light" class="ion-margin-vertical">
        <ion-label class="ion-text-wrap">
          <strong>{{ token }}</strong>
        </ion-label>
      </ion-item>

      <p class="ion-margin-top">
        <ion-text color="warning">
          <strong>Achtung:</strong> Bewahre diesen Token sicher auf! Geht er
          verloren, muss die gesamte Site im Portal gelöscht und neu angelegt
          werden, um einen neuen Token zu erzeugen.
        </ion-text>
      </p>
      <qrcode [qrdata]="token" [width]="256"></qrcode>
      <ion-button expand="block" color="primary" (click)="confirm()" class="ion-margin-top">
        Verstanden
      </ion-button>

    </ion-card-content>
  </ion-card>
</ion-content>
